module.exports = __webpack_public_path__ + "img/pos--icon.59c62bbe.svg";